<template>

    <div id="manage-funds">

        <div class="mb-4">
            <h1 class="text-2xl font-medium text-gray-900 capitalize">Adjust Account Fund</h1>
        </div>

        <div class="flex flex-col" v-if="loaded">
           <form action="#" method="POST" @submit.prevent="adjustFund()">

                <div class="panel">

                    <div class="panel-form">
                        <div class="panel-title">
                            <h3>Funds</h3>
                            <p>
                                Make an adjustment against an accounts fund. Enter the value in the standard format for your currency, e.g. 10 GBP would be 10.00, -10 GBP would be -10.00
                            </p>
                        </div>
                        <div class="panel-section">
                            <div class="grid grid-cols-6 gap-6">
                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('amount') }">
                                    <label for="amount" class="block text-sm font-medium text-gray-700">Amount<i></i></label>
                                    <input type="text" name="amount" id="amount" v-model="form.data.amount" required>
                                    <span v-if="form.fieldHasErrors('amount')">{{ form.getFieldError('amount') }}</span>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="flex mt-6 justify-end">

                    <div class="flex border-l-4 border-brand-500 bg-white text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-brand-400" v-if="form.successful()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <p class="text-gray-700 text-sm" v-html="form.getSuccessMessage()"></p>
                    </div>

                    <div class="flex border-l-4 border-error-500 bg-error-50 text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-error-400" v-if="form.hasError()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <p class="text-error-500 text-sm" v-html="form.getErrorMessage()"></p>
                    </div>

                    <button type="submit" class="btn-outline justify-center px-6 ml-6" @click.prevent="goBack">
                        Go Back
                    </button>

                    <button type="submit" class="btn justify-center px-6 ml-6" :disabled="form.isFormUpdating()">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" v-if="form.isFormUpdating()">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Adjust Fund
                    </button>
                </div>
            </form>

        </div>
        <Loading v-else></Loading>

    </div>

</template>

<script>
import {Funds} from "../../app/Funds/Funds";
import {FormattingMixin, NavigationMixin, PermissionMixin} from "../../support/mixins";
import Loading from "../Support/Loading";

export default {
    name: "AdjustFund",
    mixins: [PermissionMixin, NavigationMixin, FormattingMixin],
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new Funds();
            resolve(true);
        }).then(result => {
            vm.loaded = result;
        });
    },
    methods: {
        adjustFund() {
            let routeParams = this.$router.currentRoute.params;
            this.form.adjustFund(routeParams.fund, routeParams.account).then(() => {
                this.$router.push({name: 'accounts.show', params: {'id': routeParams.account}});
            });
        }
    }
}
</script>


